module.exports = __webpack_public_path__ + "img/portraits_23_V.0e7cd247.webp";